export default "__VITE_ASSET__CGhH8l2H__"